import { FC } from "react";
import { LoginUIMode } from "../../../enum/login.ui.mode";
import { useChangePasswordMutation } from "../../../state/api/user.api";
import { changeLoginMode } from "../../../state/slice/appSlice";
import { useAppDispatch } from "../../../state/store";
import { ChangePassword } from "./changePassword";
import { PopupManager } from "../../../util/popupManager";

interface Props {
  phone: string;
  country: string;
}
export const ChangePasswordContainer: FC<Props> = ({country, phone}) => {
  const dispatch = useAppDispatch();
  const [changePassword, {isLoading}] = useChangePasswordMutation();

  const handleChangePassword = async (args: {
    identifier: string;
    password: string;
  }) => {
    const result: any =  await changePassword(args);
    if(!result.error) {
      PopupManager.showSuccessToast('Password changed successfully');
      dispatch(changeLoginMode(LoginUIMode.SIGN_IN));
    }
  };

  return <ChangePassword country={country} identifier={phone} loading={isLoading} onChangePassword={handleChangePassword}/>;
};


